import { IOption } from "@skf/bt-wind-rail-commonlibrary/dist/components/form/types";

export const IndustryOptions: IOption[] = [{value: 0, label:"Wind", labelToShow: "Wind"}];